import React from 'react';
import ReactDOM from 'react-dom';
import AccountsApp from './accounts-app';
import reportWebVitals from './reportWebVitals';
import DOMPurify from 'dompurify';
import { setAppElement } from 'react-modal';

const TEMPORARY_ATTRIBUTE = 'data-temp-href-target'

DOMPurify.addHook('beforeSanitizeAttributes', function (node) {
    if (node.tagName === 'A') {
        if (!node.hasAttribute('target')) {
            node.setAttribute('target', '_self')
        }

        if (node.hasAttribute('target')) {
            node.setAttribute(TEMPORARY_ATTRIBUTE, node.getAttribute('target')!)
        }
    }
});

DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    if (node.tagName === 'A' && node.hasAttribute(TEMPORARY_ATTRIBUTE)) {
        node.setAttribute('target', node.getAttribute(TEMPORARY_ATTRIBUTE)!)
        node.removeAttribute(TEMPORARY_ATTRIBUTE)
        if (node.getAttribute('target') === '_blank') {
            node.setAttribute('rel', 'noopener')
        }
    }
});

const rootElement = document.getElementById('accounts-root');
setAppElement(rootElement!);

ReactDOM.render(
    <React.StrictMode>
        <AccountsApp />
    </React.StrictMode>,
    rootElement
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
